import * as React from "react";
const SvgLoveIt = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	overflow: "visible",
	viewBox: "0 0 24 24",
	id: "love-it_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M23.3 5.08a6.57 6.57 0 0 0-10.44-1.71l-.86.78-.83-.76a6.53 6.53 0 0 0-5.69-1.8A6.45 6.45 0 0 0 .7 5.08a6.38 6.38 0 0 0 1.21 7.46l9.37 9.66a1 1 0 0 0 1.44 0l9.36-9.64a6.4 6.4 0 0 0 1.22-7.48" }));
export { SvgLoveIt as ReactComponent };
